<script lang="ts">
	import { page } from "$app/state";
	import LanguagePicker from "#lib/SubLayoutLanguagePicker.svelte";
	import type { LayoutData } from "./$types";

	interface Props {
		children?: import("svelte").Snippet;
		data: LayoutData;
	}

	let { children, data }: Props = $props();
</script>

{#if (data?.languages?.length || 1) > 1}
	<LanguagePicker href={page.url.pathname} languages={data?.languages}>
		{@render children?.()}
	</LanguagePicker>
{:else}
	{@render children?.()}
{/if}
